'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollPercentage = exports.getEnabled = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _scrollPercentageTriggerKeyPaths = require('../constants/scrollPercentageTriggerKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEnabled = exports.getEnabled = (0, _getIn2.default)(_scrollPercentageTriggerKeyPaths.ENABLED);

var getScrollPercentage = exports.getScrollPercentage = (0, _getIn2.default)(_scrollPercentageTriggerKeyPaths.SCROLL_PERCENTAGE);